export var DEFAULT_CONTAINER_CLASS_NAME = 'continuous-scroll-container';